import { useState } from 'react';
import styled from 'styled-components';
import MessageForm from './MessageForm';
import MessageList from './MessageList';

const GuestBook = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isActive, setActive] = useState(false);

  const handleNewMessage = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <StyledSection>
      <h2>To. 영준&유진 📮</h2>
      {isActive && (
        <MessageForm onMessageAdded={handleNewMessage} setActive={setActive} />
      )}
      <MessageList refreshTrigger={refreshTrigger} />
      <StyledButton type="button" onClick={() => setActive(true)}>
        작성하기
      </StyledButton>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  padding: 4rem 0;
  background: var(--main-background);

  & > h2 {
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: center;
    margin-bottom: 3rem;
  }
`;

const StyledButton = styled.button`
  display: block;
  margin: 3rem auto 0 auto;
  font-family: var(--pretendard);
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--grayLv3);
  padding: 0.5rem;
`;

export default GuestBook;
